import { KTSVG } from "_metronic/helpers";
import { useAuth } from "app/context/auth-context";
import { UrlBuilder, UrlParamReplace } from "app/helpers/MiscUtils";
import { AdminRoutes } from "app/modules/admin/AdminPage";
import { JobfairService } from "app/services/JobfairService";
import { JobFair, Roles } from "app/types";
import { Pencil, DoorOpen } from "react-bootstrap-icons";
import { Button } from "react-bootstrap-v5";
import { useHistory } from "react-router-dom";

interface JobfairCardProps {
    fair: JobFair;
    onActivationToggle?: (fair: JobFair) => void;
    onEditJobFair?: (fair: JobFair) => void;
}

export const JobfairCard = (props: JobfairCardProps) => {
    const history = useHistory();
    const jobfairService = new JobfairService();
    const { user } = useAuth();
    const handleActivation = async (fair: JobFair) => {
        const updatedFair = {
            ...fair,
            isActivated: !fair.isActivated
        };

        await jobfairService.updateJobFair(updatedFair).then(() => {
            if (props.onActivationToggle)
                props.onActivationToggle(updatedFair);
        })
    };

    return (<div className='col-md-6 col-xl-4 mt-10 pt-10'>
        <div className='card border border-2 border-gray-300 bg-white shadow-sm'>
            <div className='card-header border-0 pt-9 ribbon ribbon-start ribbon-clip'>
                <div className='card-title ms-3'>
                    <span>{props.fair.name}</span>
                </div>
                {user?.roles?.includes(Roles.Admin) &&
                    < div className='toolbar'>
                        <Button variant='link' onClick={() => {
                            history.push(UrlBuilder(AdminRoutes.Lobby, { orgId: props.fair.companyId, jobFairId: props.fair.id }));
                        }}><DoorOpen></DoorOpen> Lobby</Button>

                        <Button className="ms-5" variant='link' onClick={() => { if (props?.onEditJobFair) props.onEditJobFair(props.fair) }}>
                            <Pencil></Pencil>
                        </Button>
                    </div>}
                {props.fair.paymentStatus == 'Paid' && <div className={`ribbon-label`}>
                    Paid
                    <span className="ribbon-inner bg-success"></span>
                </div>}
            </div>
            <div className='card-body p-9'>
                <p className='fw-bold fs-5 mt-1 mb-7'>
                    <KTSVG path='/media/icons/duotone/General/Scale.svg' className='svg-icon svg-icon-2 me-2' />Duration: {props.fair.durationHours}h {props.fair.durationMinutes}m
                </p>
                <div className='d-flex flex-row mb-5'>
                    <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-7 mb-3'>
                        <div className='d-flex'>
                            <div>
                                <KTSVG path='/media/icons/duotone/Interface/Calendar.svg' className='svg-icon svg-icon-2 me-2' />
                            </div>
                            <div>
                                <div className='fs-7 text-gray-500'>Start Date</div>
                                <div className='fs-7 text-gray-800 fw-bolder'>{props.fair.startDate}</div>
                            </div>
                        </div>
                    </div>
                    <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 mb-3'>
                        <div className='d-flex'>
                            <div>
                                <KTSVG path='/media/icons/duotone/Code/Time-schedule.svg' className='svg-icon svg-icon-2 me-2' />
                            </div>
                            <div>
                                <div className='fs-7 text-gray-500'>Start Time</div>
                                <div className='fs-7 text-gray-800 fw-bolder'>{props.fair.startTime}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='d-flex flex-row mb-5'>
                    {props.fair.isActivated && 
                    <div className="w-100">
                        <label className='form-label fw-bold'>Job seeker Onboarding Link</label>
                        <div className='input-group'>
                            <input title={`https://videojobfairs.com/job-seeker/organizations/${props.fair.companyId}/jobfairs/${props.fair.id}`} type='text' className='form-control form-control-solid' value={`https://videojobfairs.com/job-seeker/organizations/${props.fair.companyId}/jobfairs/${props.fair.id}`} readOnly />
                            <div className='input-group-append'>
                                <span className='input-group-text cursor-pointer d-flex align-items-center' onClick={() => {
                                    navigator.clipboard.writeText(`https://videojobfairs.com/job-seeker/organizations/${props.fair.companyId}/jobfairs/${props.fair.id}`);
                                    const label = document.getElementById(`copy-label-${props.fair.id}`);
                                    label!.classList.remove('d-none');
                                    setTimeout(() => label!.classList.add('d-none'), 2000);
                                }}>
                                    <KTSVG path='/media/icons/duotone/General/Copy.svg' className='svg-icon-2' />
                                    <span id={`copy-label-${props.fair.id}`} className='ms-2 text-success fw-bold d-none'>Copied!</span>
                                </span>
                            </div>
                        </div>
                    </div>
                    }
                </div>

                {user?.roles?.includes(Roles.Admin) &&
                    <>
                        <div className='d-flex justify-content-between align-items-center mb-5'>
                            <span className={`badge badge-lg ${props.fair.isActivated ? 'badge-light-success' : 'badge-light-danger'}`}>
                                {props.fair.isActivated ? '✓ Activated' : '✗ Not Activated'}
                            </span>

                            <Button
                                id={`toggle-${props.fair.id}`}
                                variant={props.fair.isActivated ? 'danger' : 'primary'}
                                size="sm"
                                onClick={() => handleActivation(props.fair)}
                            >
                                {props.fair.isActivated ? 'Deactivate' : 'Activate'}
                            </Button>

                        </div></>}
            </div>
        </div>
    </div >);
}
